import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-6`}
`;

const Textarea = styled.textarea`
  ${tw`w-full p-4 border border-border-default rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent resize-none`}
  min-height: 200px;
`;

const CharCount = styled.div`
  ${tw`text-right text-sm text-text-secondary mt-2 mb-4`}
`;

const ContinueButton = styled.button<{ disabled: boolean }>`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto`}
  ${props =>
    props.disabled
      ? tw`bg-bg-secondary text-text-tertiary cursor-not-allowed`
      : tw`bg-black text-white hover:bg-black-hover`}
`;

const MAX_LENGTH = 2000;

const DamageDescriptionStep: React.FC<StepProps> = ({ formData, updateFormData, onNext }) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.slice(0, MAX_LENGTH);
    updateFormData({ damageDescription: value });
  };

  const canContinue = !!formData.damageDescription && formData.damageDescription.trim().length > 0;
  const charCount = formData.damageDescription?.length || 0;

  return (
    <Container>
      <SectionLabel>DAMAGE DETAILS</SectionLabel>
      <Title>Please describe the damage to the vehicle as best you can</Title>

      <Textarea
        placeholder="Describe what happened and the extent of the damage..."
        value={formData.damageDescription || ''}
        onChange={handleChange}
        maxLength={MAX_LENGTH}
      />
      <CharCount>
        {charCount}/{MAX_LENGTH}
      </CharCount>

      <ContinueButton disabled={!canContinue} onClick={onNext}>
        Continue
      </ContinueButton>
    </Container>
  );
};

export default DamageDescriptionStep;
